var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CModal,
    {
      attrs: {
        value: true,
        size: "xl",
        title: "Select a product spec for your design",
      },
      on: { closed: _setup.onClose },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center w-100",
                },
                [
                  _c(_setup.CButton, {
                    attrs: { variant: "secondary", text: "Cancel" },
                    on: { click: _setup.onClose },
                  }),
                  _vm._v(" "),
                  !_setup.specDetails.show
                    ? _c(_setup.CButton, {
                        attrs: {
                          variant: "primary",
                          disabled: !Boolean(_setup.selectedProduct),
                          text: _setup.nextBtnText,
                        },
                        on: { click: _setup.onNextHandler },
                      })
                    : _c(
                        "div",
                        [
                          _c(_setup.CButton, {
                            attrs: { variant: "outline-primary", text: "Back" },
                            on: { click: _setup.resetSpecDetails },
                          }),
                          _vm._v(" "),
                          _c(_setup.CButton, {
                            attrs: {
                              variant: "primary",
                              text: "Confirm",
                              disabled: !_setup.specDetails.selectedPrintArea,
                            },
                            on: {
                              click: function ($event) {
                                return _setup.emitProductSpecs(
                                  _setup.specDetails.selectedTemplate?.id,
                                  _setup.specDetails.selectedPrintArea
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      !_setup.specDetails.show
        ? _c(
            "div",
            { staticClass: "product-list-wrapper" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center",
                },
                [
                  _c(_setup.CSwitch, {
                    attrs: { options: _setup.filters },
                    on: {
                      input: function ($event) {
                        return _setup.onPageChange({ page: 1, from: 0 })
                      },
                    },
                    model: {
                      value: _setup.selectedSpecMode,
                      callback: function ($$v) {
                        _setup.selectedSpecMode = $$v
                      },
                      expression: "selectedSpecMode",
                    },
                  }),
                  _vm._v(" "),
                  _c(_setup.CSelect, {
                    staticClass: "ml-auto mr-2 w-25",
                    attrs: {
                      placeholder: "Filter PODs",
                      searchable: "",
                      filterable: "",
                      clearable: "",
                      "model-transform": _setup.valueReducer,
                      options: _setup.podOptions,
                    },
                    on: {
                      input: function ($event) {
                        return _setup.onPageChange({ page: 1, from: 0 })
                      },
                    },
                    model: {
                      value: _setup.pagination.provider,
                      callback: function ($$v) {
                        _vm.$set(_setup.pagination, "provider", $$v)
                      },
                      expression: "pagination.provider",
                    },
                  }),
                  _vm._v(" "),
                  _c(_setup.CInput, {
                    staticClass: "w-25",
                    attrs: {
                      placeholder: "Search products",
                      disabled: _setup.showLoader,
                      debounce: 1000,
                    },
                    on: {
                      debounce: function ($event) {
                        return _setup.onPageChange({ page: 1, from: 0 })
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "prepend",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "input-group-text" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: ["fas", "search"] },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      20511643
                    ),
                    model: {
                      value: _setup.pagination.searchString,
                      callback: function ($$v) {
                        _vm.$set(_setup.pagination, "searchString", $$v)
                      },
                      expression: "pagination.searchString",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _setup.products.length
                ? [
                    !_setup.filterByGuidelineActive
                      ? _c(_setup.CAlert, {
                          attrs: {
                            text:
                              "For those products that do not have guidelines, only the dimensions will be imported.",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "list-container" },
                      _vm._l(_setup.products, function (product) {
                        return _c(
                          "div",
                          {
                            key: product.id,
                            staticClass: "product-card",
                            class: {
                              selected:
                                _setup.selectedProduct?.id == product.id,
                            },
                            on: {
                              click: function ($event) {
                                return _setup.onProductSeleted(product)
                              },
                            },
                          },
                          [
                            _c(
                              _setup.BoxElement,
                              { attrs: { "box-data": product } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "pod-product-badge" },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: product.object?.podImageUrl,
                                        alt: `${
                                          product.object?.pod || "pod"
                                        } logo`,
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      content: product.title,
                                      placement: "bottom",
                                      onShow: _setup.onShowTooltip,
                                    },
                                    expression:
                                      "{\n                            content: product.title,\n                            placement: 'bottom',\n                            onShow: onShowTooltip\n                        }",
                                  },
                                ],
                                staticClass: "product-title",
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(product.title) +
                                    "\n                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(_setup.CPagination, {
                      staticClass: "mx-auto mt-3",
                      attrs: {
                        size: "md",
                        disabled: _setup.showLoader,
                        "total-count": _setup.pagination.totalCount,
                        "page-count": _setup.pagination.pageSize,
                      },
                      on: { "page-change": _setup.onPageChange },
                      model: {
                        value: _setup.pagination.page,
                        callback: function ($$v) {
                          _vm.$set(_setup.pagination, "page", $$v)
                        },
                        expression: "pagination.page",
                      },
                    }),
                  ]
                : _c(_setup.CEmptyState, { staticClass: "p-5" }),
            ],
            2
          )
        : [
            _c("p", { staticClass: "font-weight-bold" }, [
              _vm._v("Select the specs you want to use for your design."),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex" }, [
              _c("div", { staticClass: "product-preview" }, [
                _c("img", {
                  staticClass: "product-thumb",
                  attrs: { src: _setup.selectedProduct?.image },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "pod-product-badge" }, [
                  _c("img", {
                    attrs: { src: _setup.selectedProduct?.object?.podImageUrl },
                  }),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "font-weight-bold" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_setup.selectedProduct?.title) +
                      "\n                "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex-grow-1 ml-2" },
                [
                  _setup.specDetails.templates.length > 1
                    ? [
                        _c("label", { staticClass: "mt-2" }, [_vm._v("Size")]),
                        _vm._v(" "),
                        _c(_setup.vSelect, {
                          attrs: {
                            label: "name",
                            placeholder: "Select",
                            "append-to-body": "",
                            options: _setup.specDetails.templates,
                          },
                          on: { "option:selected": _setup.onSizeChange },
                          model: {
                            value: _setup.specDetails.selectedTemplate,
                            callback: function ($$v) {
                              _vm.$set(
                                _setup.specDetails,
                                "selectedTemplate",
                                $$v
                              )
                            },
                            expression: "specDetails.selectedTemplate",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _setup.specDetails.printAreas.length > 1
                    ? _c(_setup.CSelect, {
                        staticClass: "mt-2",
                        attrs: {
                          label: "Print area guideline",
                          placeholder: "Select",
                          "append-to-body": "",
                          "model-transform": _setup.valueReducer,
                          options: _setup.specDetails.printAreas,
                        },
                        model: {
                          value: _setup.specDetails.selectedPrintArea,
                          callback: function ($$v) {
                            _vm.$set(
                              _setup.specDetails,
                              "selectedPrintArea",
                              $$v
                            )
                          },
                          expression: "specDetails.selectedPrintArea",
                        },
                      })
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }